import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, unref as _unref } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "sidebar-logo" }
const _hoisted_2 = {
  key: 0,
  class: "sidebar-logo-text-wrapper"
}
const _hoisted_3 = { class: "sidebar-logo-text" }
const _hoisted_4 = { class: "sidebar-nav" }
const _hoisted_5 = { class: "sidebar-nav-icon" }
const _hoisted_6 = { class: "sidebar-nav-label" }
const _hoisted_7 = {
  key: 0,
  class: "sidebar-nav-indicator"
}
const _hoisted_8 = ["title"]
const _hoisted_9 = {
  key: 2,
  class: "text-xs ml-2"
}
const _hoisted_10 = { class: "sidebar-user" }
const _hoisted_11 = { class: "sidebar-user-avatar" }
const _hoisted_12 = {
  key: 0,
  class: "sidebar-user-info"
}
const _hoisted_13 = { class: "sidebar-user-name" }
const _hoisted_14 = { class: "sidebar-user-email" }

import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import { useUser } from '@/composables/auth/useUser'
import { routes, getNavigationItems } from '@/router'
import { ChevronLeft, ChevronRight } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'Sidebar',
  props: {
    isOpen: { type: Boolean },
    collapsed: { type: Boolean }
  },
  emits: ["update:isOpen", "update:collapsed"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const route = useRoute()
const { userInitials, currentUser } = useUser()

const appTitle = computed(() => process.env.VUE_APP_TITLE || 'Diasporiques ABA Solutions LLC')
const navigation = computed(() => getNavigationItems(routes))

// Mobile detection
const isMobile = ref(false)
const checkMobile = () => {
  isMobile.value = window.innerWidth < 1024
}

onMounted(() => {
  checkMobile()
  window.addEventListener('resize', checkMobile)
})

onUnmounted(() => {
  window.removeEventListener('resize', checkMobile)
})

// Collapsed state (desktop only) - synced with parent
const isCollapsed = computed({
  get: () => props.collapsed,
  set: (val) => emit('update:collapsed', val)
})

// Mobile open state (synced with parent)
const isMobileOpen = computed({
  get: () => props.isOpen,
  set: (val) => emit('update:isOpen', val)
})

function closeMobile() {
  if (isMobile.value) {
    emit('update:isOpen', false)
  }
}

function isActive(path: string) {
  return route.path === path
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, {
      "enter-active-class": "transition-opacity duration-300 ease-out",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "transition-opacity duration-200 ease-in",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (isMobileOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "sidebar-overlay",
              onClick: closeMobile
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("aside", {
      class: _normalizeClass(["sidebar", {
      'sidebar--mobile-open': isMobileOpen.value,
      'sidebar--collapsed': isCollapsed.value && !isMobile.value
    }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("img", {
          src: _imports_0,
          alt: "Logo",
          class: "brand-logo-img"
        }, null, -1)),
        _createVNode(_Transition, {
          "enter-active-class": "transition-all duration-300 ease-out",
          "enter-from-class": "opacity-0 -translate-x-2",
          "leave-active-class": "transition-all duration-200 ease-in",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0 -translate-x-2"
        }, {
          default: _withCtx(() => [
            (!isCollapsed.value || isMobile.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(appTitle.value), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("nav", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.value, (item) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: item.to,
            to: item.to,
            class: _normalizeClass(["sidebar-nav-item", { 'sidebar-nav-item--active': isActive(item.to) }]),
            title: (isCollapsed.value && !isMobile.value) ? item.name : undefined,
            onClick: closeMobile
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { class: "h-5 w-5" }))
              ]),
              _createElementVNode("span", _hoisted_6, _toDisplayString(item.name), 1),
              (isActive(item.to))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["to", "class", "title"]))
        }), 128))
      ]),
      (!isMobile.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "sidebar-collapse-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (isCollapsed.value = !isCollapsed.value)),
            title: isCollapsed.value ? 'Expand sidebar' : 'Collapse sidebar'
          }, [
            (!isCollapsed.value)
              ? (_openBlock(), _createBlock(_unref(ChevronLeft), {
                  key: 0,
                  class: "h-4 w-4"
                }))
              : (_openBlock(), _createBlock(_unref(ChevronRight), {
                  key: 1,
                  class: "h-4 w-4"
                })),
            (!isCollapsed.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Collapse"))
              : _createCommentVNode("", true)
          ], 8, _hoisted_8))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(userInitials)), 1),
        (!isCollapsed.value || isMobile.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(currentUser)?.name || 'User'), 1),
              _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(currentUser)?.email || 'user@example.com'), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ], 64))
}
}

})